export default __webpack_public_path__ + "5f4bd3f2ce0587bc7b71b1113509bdd2.svg";